import axios from "../axios";

const getWithdrawAccounts = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('withdraw-account/getWithdrawAccounts', params,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getWithdrawAccounts;
